import React, { useState, useEffect } from 'react';
import './CustomPromptModal.css';

function CustomPromptModal({ isOpen, onClose, onSave, initialPrompt }) {
  const [prompt, setPrompt] = useState(initialPrompt || '');

  useEffect(() => {
    setPrompt(initialPrompt || '');
  }, [initialPrompt, isOpen]);

  const handleSave = () => {
    onSave(prompt);
    onClose();
  };

  const handleCancel = () => {
    setPrompt(initialPrompt || '');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="custom-prompt-overlay" onClick={handleCancel}>
      <div className="custom-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="custom-prompt-header">
          <h2>Custom AI Fill Prompt</h2>
          <button className="close-button" onClick={handleCancel}>×</button>
        </div>

        <div className="custom-prompt-body">
          <p className="prompt-instructions">
            Describe what the AI should generate in the expanded areas — e.g. "extend the
            background with the background color" or "add a solid black border".
            Leave it empty to use the built-in default prompt.
          </p>

          <label htmlFor="custom-prompt-textarea">Your Custom Prompt:</label>
          <textarea
            id="custom-prompt-textarea"
            className="custom-prompt-textarea"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Example: extend the background with a smooth gradient, maintain the same color palette, no text or objects..."
            rows={5}
          />

          <div className="prompt-tips">
            <strong>💡 Tips:</strong>
            <ul>
              <li>Be specific about what you want (e.g., "smooth gradient" vs "more background")</li>
              <li>Mention what to avoid (e.g., "no text, no patterns, no faces")</li>
              <li>Describe the style (e.g., "photorealistic", "abstract", "minimal")</li>
            </ul>
          </div>
        </div>

        <div className="custom-prompt-footer">
          <button className="btn-cancel" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className="btn-save"
            onClick={handleSave}
          >
            {prompt.trim() ? 'Use This Prompt' : 'Use Default Prompt'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CustomPromptModal;
